import React from 'react';
import './Paper.css';

export const Paper: React.FC<any> = ((props: any) => {
	return (
		<div className='da-paper' style={props.style}>{props.children}</div>
	);
});
